import type { ChangeHistory } from '@salescore/client-redux'
import { generateEltChangesChunk, type ViewConfig } from '@salescore/core'

export const getChangesChunks = (changes: ChangeHistory[], config: ViewConfig) =>
  generateEltChangesChunk(
    changes.flatMap((x) => x.changes),
    config.type === 'sheet' || config.type === 'form' ? config.tree : undefined,
  )
